<template>
  <div class="home">
    <div slot="header" style="height: 100px" class="clearfix">
      <!-- <el-select
        style="margin: 10px 20px 0; float: right"
        filterable
        v-model="planName"
        placeholder="计划选择"
        @change="planChange"
      >
        <el-option
          v-for="item in options"
          :key="item.pjpl01"
          :label="item.pjpl03"
          :value="item.pjpl01"
        ></el-option>
      </el-select> -->
      <div
        style="
          float: right;
          display: flex;
          margin: 15px 10px 0;
          align-items: center;
        "
        v-for="item in color"
        :key="item.value"
        @click="changeClick(item)"
      >
        <el-button
          class="xxbtn"
          :style="{ background: item.value, opacity: item.isClick ? 1 : 0.2 }"
        ></el-button>
        <p style="margin-left: 6px">{{ item.name }}</p>
      </div>
    </div>
    <div id="MyViewerDiv"></div>
  </div>
</template>

<script>
import {
  GetModelListByXid,
  GetModelLableList,
  GetPlanListNoJd,
  Get3DSimulate,
} from "@/setAxios";
// import $ from "jquery";
export default {
  name: "simulationModel",
  components: {},
  data() {
    return {
      color: [
        { name: "未启动", value: "#6b6b6b", isClick: true },
        { name: "未启动延期", value: "#ffffff", isClick: true },
        { name: "执行中", value: "#ff0000", isClick: true },
        { name: "已完成延期", value: "#ff9900", isClick: true },
        { name: "已完成", value: "#12a9ae", isClick: true },
        { name: "已完成提前", value: "#9933ff", isClick: true },
        { name: "执行中延期", value: "#3300ff", isClick: true },
      ],
      customColor: "#409eff",
      percentage: 0,
      days: "",
      startTime: "",
      endTime: "",
      tableData: [],
      planName: "",
      planName2: "",
      url: "",
      options: [],
      num: 0,
      setIn: null,
      Data: null,
      ziduan: 1,
      speed: "",
      options2: [{ value: 1, label: "层级" }],
      dataspeed: 1,
      thisTime: "",
      d: {},
    };
  },
  methods: {
    changeClick(item) {
      item.isClick = !item.isClick;
      EaBIM.loadTrueProgress(this.d);
      // this.getData();
    },
    planChange(data) {
      this.planName = data;
      this.options.forEach((ele) => {
        if (ele.pjpl01 == data) {
          this.planName2 = ele.pjpl03;
        }
      });
      this.getData();
    },
    GetPlanListNoJd() {
      let params = {
        xid: localStorage.xid,
        userid: localStorage.id,
      };
      GetPlanListNoJd(params).then((res) => {
        this.options = res.Data;
        this.planName = res.Data[0].pjpl01;
        this.planName2 = res.Data[0].pjpl03;
        this.getData();
      });
    },
    viewers(data) {
      EaBIM.localManyServerModelForSelects(data);
    },
    getData() {
      let params = {
        planid: this.planName,
      };
      Get3DSimulate(params).then((res) => {
        if (res.Data == null) {
          this.tableData = [];
          this.$message({
            type: "warning",
            message: "暂无模拟数据",
          });
          $("#MyViewerDiv").hide();
          return false;
        } else {
          // this.planName2 = res.Data[0].pldt04;
          $("#MyViewerDiv").show();
        }
        this.tableData = res.Data.list;
        // iframe传参
        window.parent.postMessage(
          {
            // 参数是对象数组
            data: res.Data,
          },
          "*"
        );
        this.Data = res.Data;
        this.days = res.Data.days;
        this.endTime = res.Data.endTimeN;
        this.startTime = res.Data.startTimeN;
        this.thisTime = this.startTime;
        this.d = {
          models: res.Data.models,
          type: 1,
          truePrgressList: res.Data.list,
        };
        this.showModel(this.d);
      });
    },
    showModel(data) {
      data.colors = this.color;
      this.viewers(data);
    },
  },
  created() {
    this.flushSession();
    this.GetPlanListNoJd();
  },
  mounted() {
    //this.viewers();
    document.oncontextmenu = function() {
      return false;
    };
    window.addEventListener(
      "message",
      (event) => {
        event.data.options ? (this.options = event.data.options) : "";
        event.data.planName
          ? (this.planName = event.data.planName) && this.getData()
          : "";
      },
      false
    );
  },
};
</script>

<style lang="less" scoped>
@import url("../../../../public/Content/css/style.css");
// .adsk-viewing-viewer .adsk-toolbar{
//   left: 50%;
// }
/deep/ .view {
  padding: 0;
}
#MyViewerDiv {
  height: 93%;
  top: 7%;
  width: 100%;
  position: absolute;
  // float: left;
}
.home {
  overflow: auto;
  height: 100%;
  position: relative;
}

// .aaa {
//   overflow: auto;
//   height: 5%;
//   position: absolute;
//   float: left;
//   // margin-top: 10px;
//   bottom: 0px;
//   width: 100%;
//   text-align: center;
//   // z-index: 2147483647;
//   .el-cascader {
//     margin: 3px 10px;
//   }
// }
.body_viewpoint .treeDemo_viewpoint {
  background: rgba(255, 255, 255, 0.8);
  width: 96%;
  height: 95%;
  border: none;
  overflow-y: auto;
  overflow-x: hidden;
  margin-bottom: 15px;
}
.layer-background {
  background: rgba(255, 255, 255, 0.8) !important;
}
.liveBarCodeShow {
  z-index: 10;
  position: absolute;
  width: 410px;
  // background: #eee;
}
.search-input {
  width: 140px;
}
.back {
  background: #eee;
  max-height: 500px;
  overflow: auto;
}
.el-pagination {
  white-space: pre-wrap;
}
.xxbtn {
  margin: 0 auto;
  display: block;
}
</style>
